import { SmileOutlined } from '@ant-design/icons';
import { notification } from 'antd/lib';

export const openNotification = (message: string, description: string, icon: React.ReactNode) => {
  notification.open({
    message,
    description,
    placement: 'top',
    icon: icon || (
      <SmileOutlined
        style={{
          color: '#108ee9',
        }}
      />
    ),
    onClick: () => {
      console.log('Notification Clicked!');
    },
  });
};
